import { default as _404gIILOFSQxnMeta } from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/404.vue?macro=true";
import { default as indexE88f2j6PXFMeta } from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/admin/index.vue?macro=true";
import { default as indexhnBu13nxv5Meta } from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/auth0/callback/index.vue?macro=true";
import { default as indexSIZBR4vMsXMeta } from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/auth0/logout/index.vue?macro=true";
import { default as _91id_93Xq3swh9yDbMeta } from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/doctor/[id].vue?macro=true";
import { default as indexx1s0fyK69kMeta } from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/doctor/index.vue?macro=true";
import { default as _91id_93XFEQmaWJk2Meta } from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/email-templates/[id].vue?macro=true";
import { default as add_45newPanxNQ7A6qMeta } from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/email-templates/add-new.vue?macro=true";
import { default as index7LsiUXXpFqMeta } from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/email-templates/index.vue?macro=true";
import { default as indexzsR5aYauInMeta } from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/index.vue?macro=true";
import { default as indexQeGxyFkfTOMeta } from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/login/index.vue?macro=true";
import { default as _91id_93C1rxcNf5CSMeta } from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/payee/[id].vue?macro=true";
import { default as index9oWwsEcQbLMeta } from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/payee/index.vue?macro=true";
import { default as _91id_93e4WENOZg3tMeta } from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/rebate-hoi/[id].vue?macro=true";
import { default as index0j7DqzvoSPMeta } from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/rebate-hoi/index.vue?macro=true";
import { default as _91id_93ZSnPj8f78jMeta } from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/rebate/[id].vue?macro=true";
import { default as indexX034viSNzXMeta } from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/rebate/index.vue?macro=true";
import { default as _91month_93QQyayDFy2lMeta } from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/report/[month].vue?macro=true";
import { default as indexgi6fmS9fnXMeta } from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/report/index.vue?macro=true";
export default [
  {
    name: "404",
    path: "/404",
    component: () => import("/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/404.vue")
  },
  {
    name: "admin",
    path: "/admin",
    component: () => import("/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/admin/index.vue")
  },
  {
    name: "auth0-callback",
    path: "/auth0/callback",
    component: () => import("/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/auth0/callback/index.vue")
  },
  {
    name: "auth0-logout",
    path: "/auth0/logout",
    component: () => import("/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/auth0/logout/index.vue")
  },
  {
    name: "doctor-id",
    path: "/doctor/:id()",
    component: () => import("/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/doctor/[id].vue")
  },
  {
    name: "doctor",
    path: "/doctor",
    component: () => import("/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/doctor/index.vue")
  },
  {
    name: "email-templates-id",
    path: "/email-templates/:id()",
    component: () => import("/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/email-templates/[id].vue")
  },
  {
    name: "email-templates-add-new",
    path: "/email-templates/add-new",
    component: () => import("/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/email-templates/add-new.vue")
  },
  {
    name: "email-templates",
    path: "/email-templates",
    component: () => import("/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/email-templates/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/login/index.vue")
  },
  {
    name: "payee-id",
    path: "/payee/:id()",
    component: () => import("/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/payee/[id].vue")
  },
  {
    name: "payee",
    path: "/payee",
    component: () => import("/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/payee/index.vue")
  },
  {
    name: "rebate-hoi-id",
    path: "/rebate-hoi/:id()",
    component: () => import("/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/rebate-hoi/[id].vue")
  },
  {
    name: "rebate-hoi",
    path: "/rebate-hoi",
    component: () => import("/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/rebate-hoi/index.vue")
  },
  {
    name: "rebate-id",
    path: "/rebate/:id()",
    component: () => import("/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/rebate/[id].vue")
  },
  {
    name: "rebate",
    path: "/rebate",
    component: () => import("/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/rebate/index.vue")
  },
  {
    name: "report-month",
    path: "/report/:month()",
    component: () => import("/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/report/[month].vue")
  },
  {
    name: "report",
    path: "/report",
    component: () => import("/builds/masterbranch1/smg-lsi/smg-lsi-admin/pages/report/index.vue")
  }
]